import { Link } from "react-router-dom";
import Logo from "../images/logo/logo.png";
import { useState } from "react";

function Navbar() {
  const [nav, setNav] = useState(false);

  const openNav = () => {
    setNav(!nav);
  };

  return (
    <>
      <nav>
        {/* mobile */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className='mobile-navbar__close'>
            <i className='fa-solid fa-xmark'></i>
          </div>
          <ul className='mobile-navbar__links'>
            <li>
              <Link onClick={openNav} to='/'>
                Home
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to='/about'>
                About
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to='/models'>
                Models
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to='/testimonials'>
                Testimonials
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to='/team'>
                Our Team
              </Link>
            </li>
            <li>
              <Link onClick={openNav} to='/contact'>
                Contact
              </Link>
            </li>
          </ul>
        </div>

        {/* desktop */}

        <div className='navbar'>
          <div className='navbar__img'>
            <Link to='/' onClick={() => window.scrollTo(0, 0)}>
              {/*   <img src={Logo} alt="logo-img" />*/}
              <h2 className='text-red-500'>Quick Fix Transfer</h2>
            </Link>
          </div>
          <ul className='navbar__links'>
            <li>
              <Link className='home-link' to='/'>
                Home
              </Link>
            </li>
            <li>
              {" "}
              <Link className='about-link' to='/about'>
                About
              </Link>
            </li>
            <li>
              {" "}
              <Link className='about-link' to='/services'>
                Services
              </Link>
            </li>
            <li>
              {" "}
              <Link className='about-link' to='/about'>
                Pricing
              </Link>
            </li>
            <li>
              {" "}
              <Link className='models-link' to='/models'>
                Cars
              </Link>
            </li>
            <li>
              {" "}
              <Link className='testi-link' to='/testimonials'>
                Testimonials
              </Link>
            </li>

            <li>
              {" "}
              <Link className='contact-link' to='/contact'>
                Contact
              </Link>
            </li>
          </ul>
          {/* <div className='navbar__buttons'>
            <Link className='navbar__buttons__sign-in' to='/'>
              Sign In
            </Link>
            <Link className='navbar__buttons__register' to='/'>
              Register
            </Link>
          </div>*/}

          {/* mobile */}
          <div className='mobile-hamb' onClick={openNav}>
            <i className='fa-solid fa-bars'></i>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
